<template>
  <div class="main_profile_wrapper">
    <div class="main_table">
      <TableHeaderSection
        v-if="hasPermission('create group_cards_users')"
        :title="`${localization('Group Members')}`"
        :text="`${localization('Manage group members.')}`"
        :buttonText="`${localization('Add New Member')}`"
        :total="groupMembers.length"
        @toggleModal="showAddMemberModal"
      ></TableHeaderSection>

      <div class="header_container just_custom_table_tasks">
        <CustomTable
          :count="groupMembers.length"
          :DataItems="groupMembers"
          @Refresh="fetchMembers"
          :filter="filter"
          :title="'group_members'"
          hidden_export_import
          @reset-filters="filter = {}"
          viewName="GroupMembers"
        >
          <template #columns>
            <el-table-column prop="first_name" :label="`${localization('Name')}`">
              <template #default="{ row }">
                 <div class="pl-2">
                  <router-link :to="`/user-details/${row.id}`">
                    {{ row.first_name }} {{ row.last_name }}
                  </router-link>
                  <span class="d-block text-muted small">{{ row.email }}</span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column prop="" label="actions" width="150">
               <template slot-scope="scope">
                <div class="td-actions"  >
                  <span   >
                    <a
                      v-tooltip.top-center="`${localization('Delete Member')}`"
                      @click="removeMember(scope.row.id)"
                    >
                      <img
                        v-if="hasPermission('delete group_cards_users')"
                        role="button"
                        src="@/assets/new-theme/delete-button-table.png"
                        alt="delete"
                      />
                    </a>
                  </span>
                </div>
               </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Add Member Modal -->
    <el-dialog
      :title="localization('Add Additional Members')"
      :visible.sync="showModal"
      width="600px"
      top="5vh"
      custom-class="task-modal global_modal"
      :close-on-click-modal="true"
    >
      <div class="custom_modal_header">
        <div class="images">
           <img src="@/assets/new-theme/icons/users-plus.png" alt="file" />
          <img
            @click="closeModal"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title font-weight-bold mt-3">
          {{ localization("Add Additional Members") }}
        </h3>
        <p class="description">
          {{ localization("Add new members to the group.") }}
        </p>
      </div>
      <el-form :model="form" ref="addMemberForm">


        <el-form-item :label="localization('Institution Users')">
            <el-select
              v-model="form.institution_users"
              multiple
              filterable
              :placeholder="localization('Select institution users')"
              class="w-100"
            >
              <el-option
                v-for="user in institutionUsersList"
                :key="user.id"
                :label="user.first_name + ' ' + user.last_name"
                :value="user.id"
              ></el-option>
            </el-select>
        </el-form-item>
        

      </el-form>
      <div class="lci_modal_buttons mt-5">
        <button @click="closeModal" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitAddMembers" class="lci_btn save lci_btn_modal_cancel">
          {{ localization("Save") }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// Use CustomTable as seen in index.vue, assuming it's globally registered or I need to find where it is imported.
// In index.vue it is used. I'll assume global or I check main.js. 
// Wait, index.vue didn't import CustomTable explicitly in the script shown in `view_file` (lines 1-280 of index.vue).
// Let me check index.vue imports again. Ah, likely globally registered or imported in a truncated part?
// Reading index.vue lines 135-241 shows imports: mapGetters, Swal. 
// If CustomTable is not imported in index.vue, it must be global.
// I will proceed assuming it is global or handled by matching index.vue.
// UPDATE: I will import mapGetters.

import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "DataCardsShow",
  data() {
    return {
      filter: {},
      showModal: false,
      localLoading: false,
      form: {
        institution_users: []
      }
    };
  },
  computed: {
    ...mapGetters("data_cards", ["groupMembers", "loading"]),

    ...mapGetters("groups", {
       institutionUsersList: "getInstUsers"
    }),
  },
  methods: {
    fetchMembers() {
       this.$store.dispatch("data_cards/GetGroupMembers", this.$route.params.id);
    },
    showAddMemberModal() {
      this.showModal = true;
      // Fetch contacts using the list endpoint

      // Fetch institution users
      this.$store.dispatch("groups/institutionUsersGroup");
    },
    closeModal() {
      this.showModal = false;
      this.form.institution_users = [];
    },
    submitAddMembers() {
      // Use only institution_users
      const uniqueUsers = [...this.form.institution_users];

      const payload = {
        id: this.$route.params.id,
        data: {
           users: uniqueUsers
        }
      };
      
      this.$store.dispatch("data_cards/UpdateGroup", payload).then(() => {
        this.closeModal();
        this.fetchMembers();
         Swal.fire({
            title: "",
            icon: "success",
            text: `${this.localization("Saved")}`,
            confirmButtonText: `${this.localization("Ok")}`,
            type: "success",
            confirmButtonClass: "btn btn-success",
            buttonsStyling: false,
          });
      });
    },
    removeMember(userId) {
       Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
            this.$store.dispatch("data_cards/RemoveGroupMember", {
                id: this.$route.params.id,
                userId: userId
            }).then(() => {
                this.fetchMembers();
                 Swal.fire({
                    title: "",
                    icon: "success",
                    text: `${this.localization("Deleted")}`,
                    confirmButtonText: `${this.localization("Ok")}`,
                    type: "success",
                    confirmButtonClass: "btn btn-success",
                    buttonsStyling: false,
                  });
            });
        }
      });
    }
  },
  mounted() {
    this.fetchMembers();
  }
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 30px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;
}
</style>
